var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.975 13.8L6.03752 13.1375C5.72085 13.1041 5.51669 12.9354 5.42502 12.6312C5.33335 12.327 5.40835 12.0708 5.65002 11.8625L15.225 3.47495C15.25 3.44995 15.2834 3.42912 15.325 3.41245C15.3667 3.39578 15.425 3.38745 15.5 3.38745C15.6167 3.38745 15.7146 3.4437 15.7938 3.5562C15.8729 3.6687 15.875 3.78328 15.8 3.89995L11.9625 10.2125L17.9375 10.8875C18.2542 10.9208 18.4625 11.0854 18.5625 11.3812C18.6625 11.677 18.5917 11.9291 18.35 12.1375L8.78752 20.5375C8.75419 20.5708 8.71669 20.5895 8.67502 20.5937C8.63335 20.5979 8.57919 20.6 8.51252 20.6C8.38752 20.6 8.29377 20.5479 8.23127 20.4437C8.16877 20.3395 8.16669 20.2333 8.22502 20.125L11.975 13.8Z",
    fill: "#6A7186"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/Thunder.3cfd3a0a45fd73fdb8cf5765a63da1cb.svg";
export { ForwardRef as ReactComponent };